import React from 'react';
import { navigate } from 'gatsby-link';
import { ReferenciaContenido } from "interfaces/ReferenciaContenido";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import TitleSection from "../title-section";

import "./twoButtonsBanner.scss"

const TwoButtonsBanner = (props : ReferenciaContenido) => {
    const handleClick = (redirect) => {
        navigate(redirect);
    }
    return (
        <section className="m-two-buttons-banner">
            <TitleSection title={props.tituloGeneral} />
            <div className="m-two-buttons-banner__section">
                {documentToReactComponents(props.descripcion.json)}
                <button className="m-two-buttons-banner__button" onClick={() => handleClick(props.redireccionBoton.split(";")[0])}>{props.tituloBoton.split(";")[0]}</button>
            </div>
            <div className="m-two-buttons-banner__section line">
                <p>{documentToReactComponents(props.descripcionFija.content[0].content[0])}</p>
                <button className="m-two-buttons-banner__button" onClick={() => handleClick(props.redireccionBoton.split(";")[1])}>{props.tituloBoton.split(";")[1]}</button>
            </div>
        </section>
    )
};

export default TwoButtonsBanner;